import { Page, type PageParameters } from '@lisergia/core'

import { initPdfHeader } from './PdfHeader'

export default class extends Page {
  declare element: HTMLElement

  constructor(args: PageParameters) {
    super({
      ...args,
      element: '.page:last-child',
      elements: {
        wrapper: '.page__wrapper',
      },
    })

    initPdfHeader(this.element)
  }
}
